import { useTranslation } from 'react-i18next';

import { SVGIconType } from '../../../../constants/svgIcon';
import { SvgIcon } from '../../SVGIcon';
import {
  GeneralModal,
  GeneralModalNoButtonVariant,
  GeneralModalYesButtonVariant,
} from '../GeneralModal';

import styles from './UnavailableStrokeDataModal.module.css';

type UnavailableStrokeDataModalProps = {
  missingStrokes: string[];
  onPrimary: () => void;
  onCancel: () => void;
};

export const UnavailableStrokeDataModal = (
  props: UnavailableStrokeDataModalProps,
) => {
  const { missingStrokes, onPrimary, onCancel } = props;
  const { t } = useTranslation();

  return (
    <GeneralModal
      isYesNo={true}
      onYes={onPrimary}
      onClose={onCancel}
      buttonSetting={{
        yesText: t('OK'),
        noText: t('Cancel'),
        noVariant: GeneralModalNoButtonVariant.Gray,
        yesVariant: GeneralModalYesButtonVariant.Cyan,
      }}
    >
      <div className={styles.unavailableStroke}>
        <div className={styles.centerContainer}>
          <SvgIcon name={SVGIconType.WritingJoy} className={styles.titleIcon} />
          <p className={styles.textNormal}>
            {t('Stroke data for some characters is unavailable.')}
          </p>
          <p className={styles.missingStroke}>{missingStrokes.join(' ')}</p>
        </div>
      </div>
    </GeneralModal>
  );
};
